import { z } from 'zod';

export const DIGEST_CADENCES = ['off', 'daily', 'twice_daily'] as const;
export type DigestCadence = (typeof DIGEST_CADENCES)[number];

/** True if `tz` is a resolvable IANA time zone. */
export function isValidTimeZone(tz: string): boolean {
  if (!tz) return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

/** Per-user digest preferences (persisted as User columns). */
export const digestPreferencesSchema = z.object({
  digestCadence: z.enum(DIGEST_CADENCES),
  digestHour: z.number().int().min(0).max(23),
  timezone: z.string().min(1).refine(isValidTimeZone, { message: 'Invalid IANA timezone' }),
});

export type DigestPreferences = z.infer<typeof digestPreferencesSchema>;
